import { transformAllContentItems } from "../../utils/dataTransform/library";
import { getPersonalizedItemsAlgorithmId } from "./library";
import log from "../../utils/logger/library";
import {
    receive_personalized_items,
    personalized_items_fetch_error,
} from "../../reducers/Personalization/reducer";
import { getUserFromCookie } from "../../utils/cookies/library";
import { getPersonalizedItems } from "../../fetch/graphql/requests/mlDrivenItems/library";

import { REC_FOR_YOU_DEFAULT_SIZE } from "./constants";
import { transformForLayouts } from "../../utils/dataTransform/ContentQueryWidget/library";
import { TRENDING_SWIMLANE_LAYOUT } from "../../components/LayoutFactory/constants";

export function fetch_personalized_items(
    pageSize = REC_FOR_YOU_DEFAULT_SIZE,
    path = "",
    contentId
) {
    return async (dispatch) => {
        const visitor = getUserFromCookie();

        if (!visitor) {
            log.error("(fetch_personalized_items) no visitor cookie");
            dispatch(personalized_items_fetch_error());
            return () => {};
        }

        try {
            const algorithmId = await getPersonalizedItemsAlgorithmId();
            const userId = visitor.id;

            const { data } = await getPersonalizedItems(
                algorithmId,
                userId,
                pageSize,
                contentId
            );

            const recommendationType = data?.personalizedItems?.algorithmId;

            // This is to remove sponsored content from appearing
            // Note: Since mlDrivenItems returns a list of contentItems it is safe to pass the result to transformAllContentItems
            const pre_transformation = transformAllContentItems(
                data?.personalizedItems?.nodes
            );

            const post_transformation = pre_transformation.filter(
                (item) => item?.type !== "sponsoredcontent"
            );

            const recommendedItems = transformForLayouts(
                post_transformation,
                TRENDING_SWIMLANE_LAYOUT,
                path
            );

            dispatch(
                receive_personalized_items({
                    json: recommendedItems,
                    rectype: recommendationType,
                })
            );
        } catch (error) {
            dispatch(personalized_items_fetch_error());

            log.error(`(fetch_personalized_items) failed for ${path}`, error);
        }
    };
}
